{
  "awaleScreen": {
    "header": {
      "title": "🎯 Awalé",
      "loading": "Carregando Awalé…"
    },
    "tabs": {
      "mine": "Minhas Sessões",
      "explore": "Explorar",
      "classement": "Classificação"
    },
    "mySessions": {
      "title": "Minhas Sessões",
      "emptyTitle": "Você ainda não entrou em nenhuma sessão.",
      "emptyHint": "Explore as sessões disponíveis!",
      "enter": "Entrar →",
      "runLabel": "Rodada {{number}} — {{title}}",
      "turnTime": "{{seconds}}s/turno"
    },
    "explore": {
      "title": "Sessões Disponíveis",
      "emptyTitle": "Nenhuma sessão disponível.",
      "emptyHint": "Você já pode ter entrado em todas as sessões.",
      "participateFree": "Participar gratuitamente",
      "participatePaid": "Participar ({{price}} CFA)"
    },
    "session": {
      "backToSessions": "Voltar às sessões",
      "noRunAvailable": "Nenhuma rodada disponível para esta sessão."
    },
    "run": {
      "matchFinishedTitle": "Partida Encerrada",
      "matchFinishedSub": "Esta rodada está oficialmente encerrada.\nConsulte a classificação para ver os vencedores.",
      "waitingForLaunch": "Aguardando início pelo administrador",
      "runInProgress": "Rodada em andamento",
      "notInRun": "Você não está nesta rodada",
      "playNow": "Jogar agora",
      "info": {
        "run": "Rodada",
        "prep": "Prep.",
        "turn": "Turno",
        "launched": "Iniciado"
      }
    },
    "match": {
      "yourMatch": "Sua partida",
      "you": "Você",
      "opponent": "Adversário",
      "victory": "🏆 Vitória!",
      "defeat": "❌ Derrota",
      "resultPending": "Resultado pendente"
    },
    "status": {
      "created": "⏳ Aguardando",
      "launched": "🔵 Em andamento",
      "finished": "🟢 Encerrado"
    },
    "classement": {
      "title": "Classificação",
      "emptyTitle": "Você não está inscrito em nenhuma sessão.",
      "backToClassement": "Voltar",
      "runsCount_one": "{{count}} rodada",
      "runsCount_other": "{{count}} rodadas",
      "matchesCount": "{{finished}}/{{total}} partidas",
      "noRunAvailable": "Nenhuma rodada disponível.",
      "noMatchInRun": "Nenhuma partida nesta rodada",
      "matchLabel": "Partida {{number}}",
      "matchDone": "✅ Encerrada",
      "matchLive": "🔵 Em andamento",
      "winnerLabel": "Vencedor · {{name}}"
    },
    "errors": {
      "joinSession": "Erro ao entrar na sessão",
      "loadRun": "Erro ao carregar a rodada",
      "sessionExpired": "Sessão expirada — faça login novamente"
    }
  },
  "damesScreen": {
    "header": {
      "title": "♟️ Damas",
      "loading": "Carregando Damas…"
    },
    "tabs": {
      "mine": "Minhas Sessões",
      "explore": "Explorar",
      "classement": "Classificação"
    },
    "mySessions": {
      "title": "Minhas Sessões",
      "emptyTitle": "Você ainda não entrou em nenhuma sessão.",
      "emptyHint": "Explore as sessões disponíveis!",
      "enter": "Entrar →",
      "runLabel": "Rodada {{number}} — {{title}}",
      "turnTime": "{{seconds}}s/turno"
    },
    "explore": {
      "title": "Sessões Disponíveis",
      "emptyTitle": "Nenhuma sessão disponível.",
      "emptyHint": "Você já pode ter entrado em todas as sessões.",
      "participateFree": "Participar gratuitamente",
      "participatePaid": "Participar ({{price}} CFA)"
    },
    "session": {
      "backToSessions": "Voltar às sessões",
      "noRunAvailable": "Nenhuma rodada disponível para esta sessão."
    },
    "run": {
      "matchFinishedTitle": "Partida Encerrada",
      "matchFinishedSub": "Esta rodada está oficialmente encerrada.\nConsulte a classificação para ver os vencedores.",
      "waitingForLaunch": "Aguardando início pelo administrador",
      "runInProgress": "Rodada em andamento",
      "notInRun": "Você não está nesta rodada",
      "playNow": "Jogar agora",
      "info": {
        "run": "Rodada",
        "prep": "Prep.",
        "turn": "Turno",
        "launched": "Iniciado"
      }
    },
    "match": {
      "yourMatch": "Sua partida",
      "you": "Você",
      "opponent": "Adversário",
      "victory": "🏆 Vitória!",
      "defeat": "❌ Derrota",
      "resultPending": "Resultado pendente"
    },
    "status": {
      "created": "⏳ Aguardando",
      "launched": "🔵 Em andamento",
      "finished": "🟢 Encerrado"
    },
    "classement": {
      "title": "Classificação",
      "emptyTitle": "Você não está inscrito em nenhuma sessão.",
      "backToClassement": "Voltar",
      "runsCount_one": "{{count}} rodada",
      "runsCount_other": "{{count}} rodadas",
      "matchesCount": "{{finished}}/{{total}} partidas",
      "noRunAvailable": "Nenhuma rodada disponível.",
      "noMatchInRun": "Nenhuma partida nesta rodada",
      "matchLabel": "Partida {{number}}",
      "matchDone": "✅ Encerrada",
      "matchLive": "🔵 Em andamento",
      "winnerLabel": "Vencedor · {{name}}"
    },
    "errors": {
      "joinSession": "Erro ao entrar na sessão",
      "loadRun": "Erro ao carregar a rodada",
      "sessionExpired": "Sessão expirada — faça login novamente"
    }
  },
  "tabAwale": {
    "connecting": "Conectando ao servidor…",
    "loadingMatch": "Carregando a partida…",
    "back": "Voltar",
    "connectionError": "Não foi possível conectar ao servidor",
    "prep": {
      "title": "Preparação",
      "subtitle": "A partida começa em",
      "unit": "segundos",
      "hint": "Seu adversário pode entrar a qualquer momento"
    },
    "tiebreaker": {
      "banner": "🔥 Empate — Quem chegar a 12 primeiro vence!",
      "small": "🔥 Rodada de desempate — Primeiro a 12",
      "badge": "🔥 Rodada de desempate"
    },
    "gameOver": {
      "victory": "Vitória!",
      "defeat": "Derrota",
      "reasonTimeout": "Tempo esgotado",
      "reasonScore": "Pontuação atingida",
      "reasonEmpty": "Tabuleiro vazio",
      "you": "Você",
      "opponent": "Adversário",
      "done": "Concluir"
    },
    "yourTurn": "🟢 Sua vez",
    "opponentTurn": "⏳ Vez do adversário",
    "moveNumber": "Jogada #{{number}}",
    "reconnecting": "⚠ Reconectando…"
  },
  "tabDames": {
    "connecting": "Conectando ao servidor…",
    "loadingMatch": "Carregando a partida…",
    "back": "Voltar",
    "connectionError": "Não foi possível conectar ao servidor",
    "prep": {
      "title": "Preparação",
      "subtitle": "A partida começa em",
      "unit": "segundos",
      "hint": "As vermelhas jogam primeiro"
    },
    "suddenDeath": {
      "banner": "⚡ Morte súbita — Quem chegar a {{target}} capturas primeiro vence!",
      "small": "⚡ Morte súbita — {{current}}/{{target}} capturas",
      "badge": "⚡ Morte súbita"
    },
    "gameOver": {
      "victory": "Vitória!",
      "defeat": "Derrota",
      "reasonTimeout": "Tempo esgotado",
      "reasonNoPieces": "Sem peças restantes",
      "reasonNoMoves": "Nenhum movimento possível",
      "reasonSuddenDeath": "{{target}} capturas atingidas",
      "youPlay": "Você joga com as {{color}}",
      "colorRed": "Vermelhas",
      "colorBlack": "Pretas",
      "captures": "Capturas",
      "done": "Concluir",
      "opponent": "Adversário"
    },
    "yourTurn": "🟢 Sua vez",
    "opponentTurn": "⏳ Vez do adversário",
    "chainCapture": "🔗 Captura em cadeia!",
    "youAre": "Você joga com as {{color}} ↓",
    "moveCount": "Jogada #{{number}}",
    "reconnecting": "⚠ Reconectando…",
    "movesAvailable_one": "{{count}} movimento possível",
    "movesAvailable_other": "{{count}} movimentos possíveis",
    "noMoveAvailable": "Nenhum movimento possível",
    "capturesShort": "cap."
  },
  "performanceScreen": {
    "header": {
      "title": "🎭 Performance",
      "subtitle": "Concurso de performance"
    },
    "tabs": {
      "sessions": "Sessões",
      "explore": "Explorar",
      "submit": "Enviar",
      "classement": "Classificação"
    },
    "empty": {
      "noSessionJoined": "Nenhuma sessão participada",
      "exploreHint": "Explore os concursos disponíveis",
      "noActiveRun": "Nenhuma rodada ativa para esta sessão",
      "noContestAvailable": "Nenhum concurso disponível",
      "comeBackLater": "Volte mais tarde",
      "noSubmissionOpenRun": "Nenhuma rodada aberta para envios",
      "waitAdminHint": "Aguarde o administrador abrir os envios",
      "noResultAvailable": "Nenhum resultado disponível",
      "resultsAppearHint": "A classificação aparece quando as votações estão abertas"
    },
    "noActiveRunBadge": "Nenhuma rodada ativa",
    "back": "Voltar",
    "notEnrolled": "Você ainda não está inscrito nesta rodada",
    "submitVideosButton_one": "Enviar {{count}} vídeo",
    "submitVideosButton_other": "Enviar {{count}} vídeos",
    "completeSubmissions": "Completar meus envios ({{current}}/{{max}})",
    "mySubmissions": "Meus envios ({{current}}/{{max}})",
    "participateFree": "Participar — Grátis",
    "participatePaid": "Participar — {{price}} CFA",
    "videosToSubmit_one": "{{count}} vídeo a enviar",
    "videosToSubmit_other": "{{count}} vídeos a enviar",
    "videosRequired_one": "{{count}} vídeo necessário",
    "videosRequired_other": "{{count}} vídeos necessários",
    "chooseRun": "Escolher uma rodada",
    "chooseAnotherRun": "Escolher outra rodada",
    "videosProgress_one": "{{count}} vídeo",
    "videosProgress_other": "{{count}} vídeos",
    "readyToSend": "✓ Pronto para enviar",
    "missingVideos_one": "{{count}} faltando",
    "missingVideos_other": "{{count}} faltando",
    "ruleExact": "Esta rodada exige exatamente",
    "ruleAllSlots": "Todos os espaços devem ser preenchidos antes do envio.",
    "sendVideos_one": "Enviar {{count}} vídeo",
    "sendVideos_other": "Enviar {{count}} vídeos",
    "fillAllSlots": "Preencha todos os espaços ({{ready}}/{{total}})",
    "successTitle": "✅ Envio completo",
    "successMessage_one": "Seu vídeo foi enviado com sucesso!",
    "successMessage_other": "Seus {{count}} vídeos foram enviados com sucesso!",
    "status": {
      "draft": "📝 Rascunho",
      "submissionsOpen": "🎥 Envios abertos",
      "votingOpen": "🗳️ Votação aberta",
      "finished": "🏆 Encerrado"
    },
    "slot": {
      "videoLabel": "Vídeo {{number}}",
      "alreadySubmitted": "Já enviado",
      "required": "Obrigatório",
      "tapToChoose": "Toque para escolher",
      "tapToChange": "Toque para alterar",
      "formats": "MP4 · MOV · WEBM",
      "descriptionPlaceholder": "Descrição (opcional)…"
    },
    "uploadSteps": {
      "preparing": "Vídeo {{current}}/{{total}} — Preparando…",
      "sending": "Vídeo {{current}}/{{total}} — Enviando…",
      "saving": "Vídeo {{current}}/{{total}} — Salvando…",
      "uploadFailed": "Falha ao enviar o vídeo {{number}} ({{status}})"
    },
    "permission": {
      "title": "Permissão necessária",
      "message": "Permita o acesso à sua galeria."
    }
  },
  "musicScreen": {
    "header": {
      "title": "🎵 Music",
      "subtitle": "Concurso de música"
    },
    "tabs": {
      "sessions": "Sessões",
      "explore": "Explorar",
      "submit": "Enviar",
      "classement": "Classificação"
    },
    "empty": {
      "noSessionJoined": "Nenhuma sessão participada",
      "exploreHint": "Explore os concursos disponíveis",
      "noActiveRun": "Nenhuma rodada ativa para esta sessão",
      "noContestAvailable": "Nenhum concurso disponível",
      "comeBackLater": "Volte mais tarde",
      "noSubmissionOpenRun": "Nenhuma rodada aberta para envios",
      "waitAdminHint": "Aguarde o administrador abrir os envios",
      "noResultAvailable": "Nenhum resultado disponível",
      "resultsAppearHint": "A classificação aparece quando as votações estão abertas"
    },
    "noActiveRunBadge": "Nenhuma rodada ativa",
    "back": "Voltar",
    "notEnrolled": "Você ainda não está inscrito nesta rodada",
    "submitVideosButton_one": "Enviar {{count}} vídeo",
    "submitVideosButton_other": "Enviar {{count}} vídeos",
    "completeSubmissions": "Completar meus envios ({{current}}/{{max}})",
    "mySubmissions": "Meus envios ({{current}}/{{max}})",
    "participateFree": "Participar — Grátis",
    "participatePaid": "Participar — {{price}} CFA",
    "videosToSubmit_one": "{{count}} vídeo a enviar",
    "videosToSubmit_other": "{{count}} vídeos a enviar",
    "videosRequired_one": "{{count}} vídeo necessário",
    "videosRequired_other": "{{count}} vídeos necessários",
    "chooseRun": "Escolher uma rodada",
    "chooseAnotherRun": "Escolher outra rodada",
    "videosProgress_one": "{{count}} vídeo",
    "videosProgress_other": "{{count}} vídeos",
    "readyToSend": "✓ Pronto para enviar",
    "missingVideos_one": "{{count}} faltando",
    "missingVideos_other": "{{count}} faltando",
    "ruleExact": "Esta rodada exige exatamente",
    "ruleAllSlots": "Todos os espaços devem ser preenchidos antes do envio.",
    "sendVideos_one": "Enviar {{count}} vídeo",
    "sendVideos_other": "Enviar {{count}} vídeos",
    "fillAllSlots": "Preencha todos os espaços ({{ready}}/{{total}})",
    "successTitle": "✅ Envio completo",
    "successMessage_one": "Seu vídeo foi enviado com sucesso!",
    "successMessage_other": "Seus {{count}} vídeos foram enviados com sucesso!",
    "status": {
      "draft": "📝 Rascunho",
      "submissionsOpen": "🎥 Envios abertos",
      "votingOpen": "🗳️ Votação aberta",
      "finished": "🏆 Encerrado"
    },
    "slot": {
      "videoLabel": "Vídeo {{number}}",
      "alreadySubmitted": "Já enviado",
      "required": "Obrigatório",
      "tapToChoose": "Toque para escolher",
      "tapToChange": "Toque para alterar",
      "formats": "MP3 · WAV · M4A",
      "descriptionPlaceholder": "Descrição (opcional)…"
    },
    "uploadSteps": {
      "preparing": "Áudio {{current}}/{{total}} — Preparando…",
      "sending": "Áudio {{current}}/{{total}} — Enviando…",
      "saving": "Áudio {{current}}/{{total}} — Salvando…",
      "uploadFailed": "Falha ao enviar o áudio {{number}} ({{status}})"
    }
  },
  "artisanatScreen": {
    "header": {
      "title": "🪡 Artesanato",
      "subtitle": "Concurso de artesanato"
    },
    "tabs": {
      "sessions": "Sessões",
      "explore": "Explorar",
      "submit": "Enviar",
      "classement": "Classificação"
    },
    "empty": {
      "noSessionJoined": "Nenhuma sessão participada",
      "exploreHint": "Explore os concursos disponíveis",
      "noActiveRun": "Nenhuma rodada ativa para esta sessão",
      "noContestAvailable": "Nenhum concurso disponível",
      "comeBackLater": "Volte mais tarde",
      "noSubmissionOpenRun": "Nenhuma rodada aberta para envios",
      "waitAdminHint": "Aguarde o administrador abrir os envios",
      "noResultAvailable": "Nenhum resultado disponível",
      "resultsAppearHint": "A classificação aparece quando as votações estão abertas"
    },
    "noActiveRunBadge": "Nenhuma rodada ativa",
    "back": "Voltar",
    "notEnrolled": "Você ainda não está inscrito nesta rodada",
    "submitVideosButton_one": "Enviar {{count}} vídeo",
    "submitVideosButton_other": "Enviar {{count}} vídeos",
    "completeSubmissions": "Completar meus envios ({{current}}/{{max}})",
    "mySubmissions": "Meus envios ({{current}}/{{max}})",
    "participateFree": "Participar — Grátis",
    "participatePaid": "Participar — {{price}} CFA",
    "videosToSubmit_one": "{{count}} vídeo a enviar",
    "videosToSubmit_other": "{{count}} vídeos a enviar",
    "videosRequired_one": "{{count}} vídeo necessário",
    "videosRequired_other": "{{count}} vídeos necessários",
    "chooseRun": "Escolher uma rodada",
    "chooseAnotherRun": "Escolher outra rodada",
    "videosProgress_one": "{{count}} vídeo",
    "videosProgress_other": "{{count}} vídeos",
    "readyToSend": "✓ Pronto para enviar",
    "missingVideos_one": "{{count}} faltando",
    "missingVideos_other": "{{count}} faltando",
    "ruleExact": "Esta rodada exige exatamente",
    "ruleAllSlots": "Todos os espaços devem ser preenchidos antes do envio.",
    "sendVideos_one": "Enviar {{count}} vídeo",
    "sendVideos_other": "Enviar {{count}} vídeos",
    "fillAllSlots": "Preencha todos os espaços ({{ready}}/{{total}})",
    "successTitle": "✅ Envio completo",
    "successMessage_one": "Seu vídeo foi enviado com sucesso!",
    "successMessage_other": "Seus {{count}} vídeos foram enviados com sucesso!",
    "status": {
      "draft": "📝 Rascunho",
      "submissionsOpen": "🎥 Envios abertos",
      "votingOpen": "🗳️ Votação aberta",
      "finished": "🏆 Encerrado"
    },
    "slot": {
      "videoLabel": "Vídeo {{number}}",
      "alreadySubmitted": "Já enviado",
      "required": "Obrigatório",
      "tapToChoose": "Toque para escolher",
      "tapToChange": "Toque para alterar",
      "formats": "MP4 · MOV · WEBM",
      "descriptionPlaceholder": "Descrição (opcional)…"
    },
    "uploadSteps": {
      "preparing": "Vídeo {{current}}/{{total}} — Preparando…",
      "sending": "Vídeo {{current}}/{{total}} — Enviando…",
      "saving": "Vídeo {{current}}/{{total}} — Salvando…",
      "uploadFailed": "Falha ao enviar o vídeo {{number}} ({{status}})"
    },
    "permission": {
      "title": "Permissão necessária",
      "message": "Permita o acesso à sua galeria."
    }
  },
  "artsScreen": {
    "header": {
      "title": "🎨 Arte",
      "subtitle": "Concursos criativos"
    },
    "tabs": {
      "sessions": "Sessões",
      "explore": "Explorar",
      "submit": "Enviar",
      "classement": "Classificação"
    },
    "empty": {
      "noSessionJoined": "Nenhuma sessão participada",
      "exploreHint": "Explore os concursos disponíveis",
      "noActiveRun": "Nenhuma rodada ativa para esta sessão",
      "noContestAvailable": "Nenhum concurso disponível",
      "comeBackLater": "Volte mais tarde",
      "noSubmissionOpenRun": "Nenhuma rodada aberta para envios",
      "waitAdminHint": "Aguarde o administrador abrir os envios",
      "noResultAvailable": "Nenhum resultado disponível",
      "resultsAppearHint": "A classificação aparece quando as votações estão abertas"
    },
    "noActiveRunBadge": "Nenhuma rodada ativa",
    "back": "Voltar",
    "notEnrolled": "Você ainda não está inscrito nesta rodada",
    "submitWorksButton_one": "Enviar {{count}} obra",
    "submitWorksButton_other": "Enviar {{count}} obras",
    "completeSubmissions": "Completar meus envios ({{current}}/{{max}})",
    "mySubmissions": "Meus envios ({{current}}/{{max}})",
    "participateFree": "Participar — Grátis",
    "participatePaid": "Participar — {{price}} CFA",
    "worksToSubmit_one": "{{count}} obra a enviar",
    "worksToSubmit_other": "{{count}} obras a enviar",
    "worksRequired_one": "{{count}} obra necessária",
    "worksRequired_other": "{{count}} obras necessárias",
    "chooseRun": "Escolher uma rodada",
    "chooseAnotherRun": "Escolher outra rodada",
    "worksProgress_one": "{{count}} obra",
    "worksProgress_other": "{{count}} obras",
    "readyToSend": "✓ Pronto para enviar",
    "missingWorks_one": "{{count}} faltando",
    "missingWorks_other": "{{count}} faltando",
    "ruleExact": "Esta rodada exige exatamente",
    "ruleAllSlots": "Todos os espaços devem ser preenchidos antes do envio.",
    "sendWorks_one": "Enviar {{count}} obra",
    "sendWorks_other": "Enviar {{count}} obras",
    "fillAllSlots": "Preencha todos os espaços ({{ready}}/{{total}})",
    "successTitle": "✅ Envio completo",
    "successMessage_one": "Sua obra foi enviada com sucesso!",
    "successMessage_other": "Suas {{count}} obras foram enviadas com sucesso!",
    "status": {
      "draft": "📝 Rascunho",
      "submissionsOpen": "🖼️ Envios abertos",
      "votingOpen": "🗳️ Votação aberta",
      "finished": "🏆 Encerrado"
    },
    "quota": "{{current}}/{{max}} envio",
    "quota_other": "{{current}}/{{max}} envios",
    "slot": {
      "workLabel": "Obra {{number}}",
      "alreadySubmitted": "Já enviada",
      "required": "Obrigatório",
      "tapToChoose": "Toque para escolher",
      "tapToChange": "Toque para alterar",
      "formats": "JPG · PNG · WEBP",
      "descriptionPlaceholder": "Descrição (opcional)…"
    },
    "uploadSteps": {
      "preparing": "Imagem {{current}}/{{total}} — Preparando…",
      "sending": "Imagem {{current}}/{{total}} — Enviando…",
      "saving": "Imagem {{current}}/{{total}} — Salvando…",
      "uploadFailed": "Falha ao enviar a imagem {{number}} ({{status}})"
    },
    "permission": {
      "title": "Permissão necessária",
      "message": "Permita o acesso à sua galeria."
    }
  },
  "vraiFauxScreen": {
    "title": "Verdadeiro ou Falso",
    "loading": "Carregando…",
    "tabs": {
      "sessions": "Sessões",
      "explore": "Explorar",
      "answers": "Respostas",
      "results": "Resultados"
    },
    "headerSub": {
      "groups": "GRUPOS",
      "questions": "PERGUNTAS",
      "mySessions": "MINHAS SESSÕES",
      "explore": "EXPLORAR",
      "myAnswers": "MINHAS RESPOSTAS",
      "myResults": "MEUS RESULTADOS"
    },
    "mine": {
      "emptyTitle": "Nenhuma sessão participada",
      "emptySub": "Explore as sessões disponíveis e participe!",
      "exploreAction": "Explorar",
      "groupsLabel": "GRUPOS",
      "openGroup": "Grupo aberto a todos",
      "minScore": "Pontuação mín.: {{score}} pts",
      "locked": "🔒 Necessário: {{required}} pts · Você: {{current}} pts",
      "answerButton": "Responder",
      "insufficientScore": "Pontuação insuficiente — você tem {{current}} pts, são necessários {{required}} pts",
      "allAnswered": "Todas as perguntas respondidas!",
      "backToGroups": "Voltar aos grupos",
      "questionCounter": "Pergunta {{current}} / {{total}}",
      "previous": "Anterior",
      "next": "Próxima"
    },
    "explore": {
      "allJoinedTitle": "Tudo participado!",
      "allJoinedSub": "Você participa de todas as sessões disponíveis.",
      "free": "Grátis",
      "paid": "💰 {{price}} CFA",
      "participate": "Participar"
    },
    "answers": {
      "participatedSessions": "SESSÕES PARTICIPADAS",
      "emptyTitle": "Nenhuma resposta",
      "emptySub": "Participe de uma sessão para ver suas respostas.",
      "groupsLabel": "GRUPOS — {{session}}",
      "myAnswersLabel": "MINHAS RESPOSTAS",
      "infoBanner": "As pontuações e as respostas corretas serão reveladas pelo administrador na aba Resultados",
      "emptyRunTitle": "Nenhuma resposta",
      "emptyRunSub": "Você ainda não respondeu a nenhuma pergunta neste grupo.",
      "myAnswerWas": "Eu respondi: {{answer}}"
    },
    "results": {
      "participatedSessions": "SESSÕES PARTICIPADAS",
      "emptyTitle": "Nenhum resultado",
      "emptySub": "Participe de uma sessão para ver seus resultados.",
      "groupsLabel": "GRUPOS — {{session}}",
      "pendingTitle": "Resultados ainda não revelados",
      "pendingDefaultMsg": "O administrador revelará os resultados após o encerramento da rodada.",
      "scoreRevealed": "Pontuação revelada:",
      "notPlayed": "Não jogado",
      "pointsAwarded": "+{{points}} pts"
    },
    "true": "VERDADEIRO",
    "false": "FALSO",
    "points": "{{count}} pts",
    "errors": {
      "network": "Erro de rede",
      "notConnected": "Não conectado",
      "sessionExpired": "Sessão expirada — faça login novamente",
      "submitError": "Erro ao enviar"
    }
  }
}
